import { $host } from "./index";

export const fetchReviewRequests = async (page = 1, size = 10) => {
  const { data } = await $host.get(`web/pointsapplications?page=${page - 1}&size=${size}`);
  return data;
};

export const fetchReviewRequestById = async (id) => {
  const { data } = await $host.get(`web/pointsapplications/${id}`);
  return data;
};

export const getPendingReviewRequestsCount = async () => {
  const { data } = await $host.get("web/pointsapplications/pending-count");
  return data;
};

export const fetchReviewRequestImage = async (id) => {
  const { data } = await $host.get(`web/pointsapplications/img/${id}`, { responseType: "blob" });
  return URL.createObjectURL(data);
};

export const processReviewRequest = async (reviewRequestId, decision, decisionComment = "") => {
  const { data } = await $host.post("web/pointsapplications/points-for-review", {
    pointsApplicationId: reviewRequestId,
    selected: decision,
    decisionComment,
  });
  return data;
};
